/**
 * @fileoverview useClockAnchor — both clocks, read when a deadline or stamp is first seen
 * @package @puffin-core/countdown
 * @module useClockAnchor
 */

import { useState } from 'react';

import { readClocks } from './countdownClock.js';

/**
 * The anchor for `value`: both clocks as they read when this component first saw `value`. A new value takes a new
 * anchor in the same render, so no render measures a new deadline from an old anchor.
 *
 * @param {?number} value - The deadline or stamp the anchor belongs to (null when there is none).
 * @returns {import('./countdownClock').ClockReading}
 */
export function useClockAnchor(value) {
  const [anchor, setAnchor] = useState(() => ({ value, clocks: readClocks() }));
  if (!Object.is(anchor.value, value)) {
    const next = { value, clocks: readClocks() };
    setAnchor(next);
    return next.clocks;
  }
  return anchor.clocks;
}
